import React, {
  useRef,
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
  useMemo,
} from "react";
import SearchPanel from "../../../../../widgets/SearchPanel";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitFormData } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import { ColumnConfig } from "@shared/components/Grid/types";
import SnGrid from "@shared/components/GridV2/SnGrid";
import { menuInfo } from "@shared/type/CommonType";
import SnResizeBar from "@shared/components/SnResizeBar";

interface Props {
  Menuprops: menuInfo;
}

const SN_PRD_WRK_REP_004_CHEM = forwardRef(({ Menuprops }: Props, ref) => {
  const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
    grid1: React.createRef(),
    grid2: React.createRef(),
  });
  const [columns, setColums] = useState<any>({
    grid1: [],
    grid2: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
    grid2: [],
  });
  const searchRef = useRef<any>(null);
  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const today = new Date();
  const todayform = `${today.getFullYear()}${(today.getMonth() + 1)
    .toString()
    .padStart(2, "0")}${today.getDate().toString().padStart(2, "0")}`;
  const popDate = new Date();
  popDate.setDate(1);
  const firstDayOfMonth = `${popDate.getFullYear()}${(popDate.getMonth() + 1)
    .toString()
    .padStart(2, "0")}${popDate.getDate().toString().padStart(2, "0")}`;

  const { userInfo } = global();

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData();
        setFormData(rtn.formData);
        setFormControlData(rtn.formControlData);
        setColums({
          grid1: rtn.grid.grid1,
          grid2: rtn.grid.grid2,
        });
      } catch (error) {}
    };
    fetchform();
  }, []);

  const onSearch = async () => {
    try {
      const param = {
        id: "sn_prd_wrk_rep_004_chem_01",
        params: searchRef.current.getFormdata(),
      };

      const data: any = await fnGetDataSet(param);

      setDataSources({
        grid1: data[0],
        grid2: data[1],
      });
    } catch (error) {}
  };
  const onFocusedRowChanged = (event: any) => {
    const selectedRow = event;
    if (selectedRow) {
      const no_wo = selectedRow.no_wo;
      gridRefs.current["grid2"].current.applyFilters({
        no_wo: no_wo,
      });
      gridRefs.current["grid2"].current.selectAndFocusRow(0);
    } else {
      return;
    }
  };
  useImperativeHandle(ref, () => ({
    onSearch,
  }));
  const grids = useMemo(
    () => ({
      grid1: {
        columns: columns.grid1,
        dataSource: dataSources.grid1,
        events: {
          onFocusedRowChanged: onFocusedRowChanged,
        },
      },
      grid2: {
        columns: columns.grid2,
        dataSource: dataSources.grid2,
      },
    }),
    [columns, dataSources]
  );
  return (
    <div className="h-full flex flex-col">
      <div>
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
        ></SearchPanel>
      </div>
      <div className="flex w-full h-full min-w-0 space-x-1.5">
        <SnResizeBar direction={"width"} id="panel1" orgSize="25.5%">
          <SnGrid
            ref={gridRefs.current["grid1"]}
            columnConfig={grids.grid1.columns}
            rowData={grids.grid1.dataSource}
            etcProps={{
              isEditable: true,
              rowSelection: "single",
              title: "LOT정보",
            }}
            events={grids.grid1.events}
          />
        </SnResizeBar>
        <SnResizeBar direction={"width"} id="panel2" orgSize="74%">
          <SnGrid
            ref={gridRefs.current["grid2"]}
            columnConfig={grids.grid2.columns}
            rowData={grids.grid2.dataSource}
            etcProps={{
              isEditable: true,
              rowSelection: "multiple",
              title: "배합정보",
            }}
          />
        </SnResizeBar>
      </div>
    </div>
  );
});

export default SN_PRD_WRK_REP_004_CHEM;
